import { render, staticRenderFns } from "./label_manage.vue?vue&type=template&id=5927c11d&scoped=true"
import script from "./label_manage.vue?vue&type=script&lang=js"
export * from "./label_manage.vue?vue&type=script&lang=js"
import style0 from "./label_manage.vue?vue&type=style&index=0&id=5927c11d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927c11d",
  null
  
)

export default component.exports